export default {
    scrollToId(id, offset = 0) {
        window.scrollBy({
            top:      document.getElementById(id).getBoundingClientRect().top - offset,
            behavior: 'smooth'
        });
    },

    scrollToTop(offset = 0) {
        window.scroll({top: offset, behavior: 'smooth'});
    },

    objectToParams(obj) {
        let params = [];
        for (let key in obj)
            params.push(`${key}=${obj[key]}`);
        return params.join('&');
        // return Object.entries(obj).map(([key, value]) => `${key}=${value}`).join('&');
    },

    secondsToTime(s) {
        return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;
    },

    isMobile() {
        return document.documentElement.clientWidth < 992;
    }
};